// extracted by mini-css-extract-plugin
export default {"hover":"style_hover__l76Wo"};